export const SET_FETCHING = 'checkoutPage/additionalServices/SET_FETCHING';
export const SET_ADDITIONAL_SERVICES = 'checkoutPage/additionalServices/SET_ADDITIONAL_SERVICES';
export const RESET_ADDITIONAL_SERVICES = 'checkoutPage/transfers/RESET_ADDITIONAL_SERVICES';
